import { TypographyHeading } from "shared/molecules/typography-layout";
import { Nl3LiveclassSchedulesFilter } from "./filter";
import { Box, InputLabel, Paper, Typography, FormControl, Select, MenuItem, Pagination } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { GET_NLEARN3_LIVECLASS_PACKAGES, GET_NLEARN3_PACKAGE_SCHEDULES } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material"
import { table } from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import ContentRight from "shared/molecules/content-right";
import { Link, useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import { CREATE_STUDENT_SESSION_ALLOCATIONS } from "utils/graphql/services/live-classes/mutations";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useAppDispatch } from "hooks/redux";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { useHostLink } from "./host-link";


export default function Nl3PackageSchedules() {

    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [clearValuesTrigger, setClearValuesTrigger] = useState(0);
    const [limit, setLimit] = useState(10);
    const dispatch = useAppDispatch();

    const [createSessionAllocations] = useMutation(CREATE_STUDENT_SESSION_ALLOCATIONS, {
        client: liveClassClientService,
    });

    const history = useHistory();

    async function handleSessionAllocations(row: any) {
        console.log("row",row.nlearn3LiveclassPackageIds)
        try {
            const response = await createSessionAllocations({
                variables: {
                    input: {
                        projectId: row?.liveSession?.projectId,
                        vendorId: row?.liveSession?.vendorId,
                        liveSessionId: row?.liveSessionId,
                        liveclassPackageIds: row?.nlearn3LiveclassPackages?.map((pkg: any) => pkg.id) || [],
                    },
                },
            });
            if (response?.data?.createSessionAllocations) {
                dispatch(
                    snackbarRequest({
                        message:
                            response?.data?.createSessionAllocations?.message ||
                            "Session allocated successfully",
                    })
                );
            }

        } catch (err: any) {

            const errorMessage =
                err?.graphQLErrors?.[0]?.message ||
                "Failed to allocate session";

            dispatch(
                snackbarRequest({
                    message: errorMessage,
                    type: "error",
                })
            );
        }


    }

    function handleAllocatedSessions(row: any) {
        history.push(`/live-classes/nlearn3-package-schedules/allocated-sessions`, { row });
    }

    function handleLiveSessions(row: any) {
        history.push(`/live-classes/nlearn3-package-schedules/live-sessions`, { row });
    }

    function handleSessionUsages(row: any) {
        history.push(`/live-classes/nlearn3-package-schedules/session-usages`, { row });
    }

    function handleCoHost(row: any) {
        history.push(`/live-classes/nlearn3-package-schedules/co-host`, { row });
    }
    function handleObserver(row: any) {
        history.push(`/live-classes/nlearn3-package-schedules/observer`, { row });
    }
    const { handleScheduleCopy } = useHostLink();

    const [Nl3LiveclassSchedulesList, { loading, error, data }] = useLazyQuery(
        GET_NLEARN3_PACKAGE_SCHEDULES,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        Nl3LiveclassSchedulesList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

    const nl3LiveclassSchedulesData = (
        data?.getNlearn3PackageSchedules?.nlearn3PackageSchedules || []
    ).map((t: any) => ({
        ...t,
        packageName: t?.nlearn3LiveclassPackages?.map((pkg: any) => pkg?.name).join(", "),
        scheduledStartTime: utcToIst(t?.liveSession?.scheduledStartTime),
        scheduledEndTime: utcToIst(t?.liveSession?.scheduledEndTime),
        createdAt: utcToIst(t.createdAt),
        updatedAt: utcToIst(t.updatedAt),

    }));

    return (
        <>

            <ContentRight>
                <Link to="/live-classes/nlearn3-package-schedules/create">
                    <Button variant="contained">Create Nl3 Package Schedule</Button>
                </Link>
            </ContentRight>

            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Nlearn3 Liveclass Schedules{" "}
            </TypographyHeading>

            <Nl3LiveclassSchedulesFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
                clearValuesTrigger={clearValuesTrigger}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getNlearn3PackageSchedules?.nlearn3PackageSchedules?.length > 0 ? (
                        <CollapsibleTable
                            data={nl3LiveclassSchedulesData}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getNlearn3PackageSchedules?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="false"
                            showPaginationFooter={false}
                            handleLiveSessions={handleLiveSessions}
                            handleSessionAllocations={handleSessionAllocations}
                            handleSessionUsages={handleSessionUsages}
                            handleAllocatedSessions={handleAllocatedSessions}
                            handleScheduleCopy={handleScheduleCopy}
                            handleCoHost={handleCoHost}
                            handleObserver={handleObserver}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getNlearn3PackageSchedules?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}